<template>
  <div>
    <aside id="side-menu" class="sidebar animated slideInLeft" v-if="showSideMenu">
      <div id="leftside-navigation" class="nan">
        <ul class="nano-content">

          <li class="sub-menu active">
            <a class="pointer" @click="handleHome">
              <icon name="home" class="fa-position"></icon>
              <span>Home</span>
            </a>
          </li>
          <li v-show="statusLogin" @click="handleMyAccount">
            <a class="pointer">
              <icon name="user-circle-o" class="fa-position"></icon>
              <span>Account</span>
            </a>
          </li>
        <!--
          <li class="sub-menu" @click="categoriesContent = !categoriesContent">
            <a class="pointer">
              <icon name="book" class="fa-position"></icon>
              <span>Book Categories</span>
              <icon name="angle-right" class="arrow-position pull-right"></icon>
            </a>
              <ul id="side-menu" class="fadeIn animated" v-bind:class="{ subMenuOpenClose: categoriesContent }">
                <li>
                  <a class="pointer">Action</a>
                </li>
                <li>
                  <a class="pointer">Adventures</a>
                </li>
                <li>
                  <a class="pointer">Comedy</a>
                </li>
                <li>
                  <a class="pointer">Documentary</a>
                </li>
                <li>
                  <a class="pointer">Family</a>
                </li>
                <li>
                  <a class="pointer">Film-Noir</a>
                </li>
                <li>
                  <a class="pointer">Horror</a>
                </li>
                <li>
                  <a class="pointer">Musical</a>
                </li>
                <li>
                  <a class="pointer">Romance</a>
                </li>
                <li>
                  <a class="pointer">Sport</a>
                </li>
                <li>
                  <a class="pointer">War</a>
                </li>
                <li>
                  <a class="pointer">Western</a>
                </li>
              </ul>
          </li>


          <li v-show="statusLogin" class="sub-menu" @click="servicesContent = !servicesContent">
            <a class="pointer">
              <icon name="wpexplorer" class="fa-position"></icon>
              <span>Services</span>
              <icon name="angle-right" class="arrow-position pull-right"></icon>
            </a>
              <ul id="side-menu" class="fadeIn animated" v-bind:class="{ subMenuOpenClose: servicesContent }">
                <li>
                  <a class="pointer">My Download</a>
                </li>
                <li>
                  <a class="pointer">My List</a>
                </li>
              </ul>
          </li>
          
          <li>
            <a class="pointer">
              <icon name="gears" class="fa-position"></icon>
              <span>App Setting</span>
            </a>
          </li>

          <li>
            <a class="pointer">
              <icon name="question-circle-o" class="fa-position"></icon>
              <span>FAQ</span>
            </a>
          </li>

          <li>
            <a class="pointer">
              <icon name="file-text-o" class="fa-position"></icon>
              <span>Terms and Condition</span>
            </a>
          </li>

          <li>
            <a class="pointer">
              <icon name="eye-slash" class="fa-position"></icon>
              <span>Privacy</span>
            </a>
          </li>

          <li>
            <a class="pointer">
              <icon name="question" class="fa-position"></icon>
              <span>Help</span>
            </a>
          </li>
        -->
          <li v-show="statusLogin">
            <a class="pointer" @click="handleSignout">
              <icon name="sign-out" class="fa-position"></icon>
              <span>Logout</span>
            </a>
          </li>

          <li v-show="!statusLogin">
            <a class="pointer" @click="handleSignin">
              <icon name="sign-in" class="fa-position" ></icon>
              <span>Login</span>
            </a>
          </li>

        </ul>
      </div>
    </aside>

    <div id="landing-body" @touchmove="preventMobileScroll" v-resize="onResize">
      <header id="cd-header align-right" style="background-color:white;">
          <div style="text-align: center;">
            <!-- <img src="images/logo.png" alt="Homepage" style="padding:5px 0px 0 10px;height:50px;"> -->
            <img @click="handleHome" src="images/SIR (Small).png" alt="Homepage" >
            <!-- <img src="images/logo2.png" alt="Homepage" style="padding:5px 0px 0 10px;height:50px;"> -->
          </div>
          

        <!--Burger menu-->
        <a class="pointer" @click="showSideMenu = !showSideMenu, hideScroll = !hideScroll, handleScroll()" id="cd-menu-trigger">
          <span class="cd-menu-text" style="color:black;">Menu</span>
          <span class="cd-menu-icon" style="background-color:black;"></span>
        </a>

        <!-- <div id="wrap"  > -->
        <div style="margin:0;display:inline-block;height:70px;float:right;padding:0;">
          <form action="" autocomplete="on" >
            <input id="search" name="search" type="text" color="black" placeholder="Search..." style="background-color:white;text-fill-color:black;">
            <input id="search_submit" value="SearchStuff" type="submit">
            <icon name="search" scale="1.4" class="search-position" style="position:absolute; top:20px;right:25px;padding:5px 5px 5xp 5px;color:black;"></icon>
          </form>
        </div>

      <div @click="showSideMenu = !showSideMenu, hideScroll = !hideScroll, handleScroll()" v-bind:class="{ paneloverlay: showSideMenu}"></div>

      </header>
    </div>

  </div>
</template>

<script>

export default 
{
  data() {
    return {
      showSideMenu: false,
      servicesContent: true,
      categoriesContent: true,
      hideScroll: false,
      windowSize: {
        x: 0,
        y: 0
      },
      resizeLogo: "padding:5px 0px 0 10px;height:50px;",
      
      changeLogo: 'images/logo.png',
      indexLogo: 0,
      statusLogin: true,
    }
  },
  // break point methods
  methods: 
  {
    
    preventMobileScroll(event){
      if(this.hideScroll){
        event.preventDefault();
        event.stopPropagation();
      } else {
        event.unbind();
      }
    },
    periodicallyChangeLogo(){
      var logoChange = ["images/logo.png","images/logo1.png","images/logo2.png"]
      if(this.indexLogo==3)
      this.indexLogo=0
    },
    handleScroll(){
      if (this.hideScroll) {
            // document.documentElement.style.overflow = 'hidden'
            // document.documentElement is the same as using document.querySelector('#root')
      } else {
        document.documentElement.style.overflow = 'auto'
      }
    },
    onResize () 
    {
          this.windowSize = { x: window.innerWidth, y: window.innerHeight }
          console.log('height:',this.windowSize.x,' width:',this.windowSize.y)
          this.changeSize()
    },
    changeSize()
    {
      if(this.windowSize.x<=800){
        console.log('go in')
        this.resizeLogo = "padding:15px 0px 0 0px;height:48px;"
      }
    },
    handleHome()
    {
        this.$router.push({
          name: "landing"
        });
    },

    
    handleMyAccount()
    {
        this.$router.push({
          name: "MyAccount"
        });
    },

    handleSignin()
    {
        this.$router.push({
          name: "login"
        });
        localStorage.removeItem('session')
    },
    handleSignout()
    {
      localStorage.removeItem('session')
      location.reload()
      
      this.handleHome();
    },

    checkLogin()
    {
      if(localStorage.getItem('session')===null)
      {
        this.statusLogin=false
      }else
      {
        
        this.statusLogin=true
      }
    },
    checkVersion(){
      // var current_version = window.location.origin+'/version.json';
      var configs = {
          headers: {'Access-Control-Allow-Origin': '*'},
          proxy: { host: '192.168.0.17', port:8081}
      };
       var current_version = this.$config.urlBase+'/version.json';
      console.log('website version:',current_version)
      this.$axios.get(current_version,configs)
        .then(function (response) {
          console.log('Version: ',response.data)
          var current_version = response.data;
          // Vue.cordova.on('deviceready', () => {
          //   console.log('LocationFile:',cordova.file.applicationDirectory)
          //   console.log('StorageDirectory:',cordova.file.applicationStorageDirectory)
          //   console.log('DeviceType: ',device.platform)
          // })
      })
      .catch(function (error) {
        console.log(error);
      });
    }
  },
  created() {
    // onFocus = window.scrollTo(0,0)
    this.checkLogin()
    
    window.scrollTo(0, 0);
  },
  
}
</script>

<style lang="scss" scoped>

img
{
  height: 79px;
  width: 213px;
}

@media only screen and (max-width: 768px) {
  img {
    height: 69.5px;
    width: 176.5px;
    margin-top: 5px;
  }
}

#side-menu{
  animation-duration: 0.5s;
  animation-delay: 0s;
}


@media (max-width: 768px) {
  #swiper-option {
    display: none;
  }
}


.banner-bg {
  margin-top: 20px;
}

#mid-banner {
  width: 100%;
  text-align: center;
  #mid-banner-img {
    margin-top: 30px;
    width: 80%;
    max-width: 1400px;
  }
}

@media (max-width: 768px){
  #mid-banner {
    #mid-banner-img {
      width: 100%;
    }
  }

  .banner-bg, #mid-banner{
    padding: 0 10px;
  }
}


.bws-tpc {
  #bws-items {
    display: inline-flex;
    margin-right: 2%;
    width: 23.25%;
    height: 100%;
    background-size: cover;
  }
  #bws-items:nth-child(4n) {
    margin-right: 0%;
  }
  #bws-items:hover {
    transition: all 0.5s cubic-bezier(0, 0, 0.25, 1);
    transform: scale(1.03);
  }
}

@media (max-width: 1200px) {
  .bws-tpc {
    #bws-items {
      margin-right: 2%;
      width: 48%;
      height: 100%;
      background-size: cover;
    }
    #bws-items:nth-child(2n) {
      margin-right: 0%;
    }
    #bws-items:nth-child(3n) {
      margin-top: 10px;
    }
    #bws-items:nth-child(4n) {
      margin-top: 10px;
    }
  }
}


/* --------------------------------

Primary style

-------------------------------- */


/*Make it scrolless and clean*/

* {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  &:after,
  &:before {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
}


/*need to set this to assign to the main element a min height of 100%*/


/* --------------------------------

Modules - reusable parts of our design

-------------------------------- */



/*.landing for side navi*/


/*give padding when switch to mobile*/

@media only screen and (max-width: 768px) {
  .landing-main-content {
    padding: 0px 0px 0px 0px;
  }
}

@media only screen and (max-width: 375px) {
  .landing-main-content h3 {
    font-size: 16px;
  }
}


/*Text style*/

#landing-top-nav a {
  display: inline-block;
  padding: 0.5em;
  color: #FFF;
  text-transform: uppercase;
  font-weight: 600;
  &.current {
    background-color: #242e30;
  }
}

.no-touch #landing-top-nav a:hover {
  color: rgba(255, 255, 255, 0.7);
}

@media only screen and (min-width: 768px) {
  #landing-top-nav {
    display: block;
  }
}



</style>



// WEBPACK FOOTER //
// SideMenu.vue?b82c539c